import { languageSelector } from './content/languageSelector';
import { getSignedInFooterNavLinks } from './content/signedInFooterNavLinks/index';
import { getSignedInHeaderNavLinks } from './content/signedInHeaderNavLinks/index';
import { getSignedOutFooterNavLinks, getLegalNavLinks } from './content/signedOutFooterNavLinks/index';
import { getSignedOutHeaderNavLinks } from './content/signedOutHeaderNavLinks/index';
import { NavigationDataType, geoCountryCode, locales } from './types';
export var getDefaultNavMenu = function getDefaultNavMenu(_ref) {
  var navigationDataType = _ref.navigationDataType,
      navigationName = _ref.navigationName,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? locales.en : _ref$locale,
      _ref$countryCode = _ref.countryCode,
      countryCode = _ref$countryCode === void 0 ? geoCountryCode.intl : _ref$countryCode;

  switch (navigationDataType) {
    case NavigationDataType.SignedOutFooter:
      return {
        navigationMenu: getSignedOutFooterNavLinks(locale, countryCode)
      };

    case NavigationDataType.SignedOutHeader:
      return {
        navigationMenu: getSignedOutHeaderNavLinks(locale, countryCode)
      };

    case NavigationDataType.SignedInFooter:
      return {
        navigationMenu: getSignedInFooterNavLinks(locale)
      };

    case NavigationDataType.SignedInHeader:
      return {
        navigationMenu: getSignedInHeaderNavLinks(locale, navigationName)
      };

    case NavigationDataType.SignedOutNavigation:
      return {
        navigationMenu: {
          SignedOutHeader: getSignedOutHeaderNavLinks(locale, countryCode),
          SignedOutFooter: getSignedOutFooterNavLinks(locale, countryCode),
          experimentIds: []
        }
      };

    case NavigationDataType.FooterLegal:
      return {
        navigationMenu: {
          LegalNav: getLegalNavLinks(locale)
        }
      };

    case NavigationDataType.AuthPageSignedOutNavigation:
      return {
        navigationMenu: {
          SignedOutHeader: getSignedOutHeaderNavLinks(locale, countryCode),
          LegalNav: getLegalNavLinks(locale),
          experimentIds: []
        }
      };

    case NavigationDataType.LanguageSelector:
      return {
        navigationMenu: languageSelector
      };

    default:
      return {
        navigationMenu: {}
      };
  }
};